module.exports = __webpack_public_path__ + "static/media/apotek-tunas-logo.7f8d1e2f.png";